import { Client } from '@stomp/stompjs';
import { getAccessToken } from '../utils/authorization';

class WSClient {
  constructor({ url, topics, reconnectDelay = 5000, params = {}, onConnect }) {
    this.brokerURL = url.replace(/^[a-z]*:/, 'wss:');
    this.params = params;
    
    this.client = new Client({
      brokerURL: this.getBrokerUrl(),
      connectionTimeout: reconnectDelay,
      reconnectDelay,
      onWebSocketClose: () => {
        const newBrokerUrl = this.getBrokerUrl();
        
        if (this.client && this.client.brokerURL !== newBrokerUrl) {
          this.client.configure({
            brokerURL: newBrokerUrl,
          });
        }
      },
      onConnect: () => {
        for (const topic of topics) {
          this.client.subscribe(topic.name, topic.handler);
        }
        
        if (onConnect) {
          onConnect();
        }
      },
    });
  }
  
  activate() {
    this.client.activate();
  }
  
  deactivate() {
    this.client.deactivate();
  }
  
  getBrokerUrl() {
    const parsedParams = [];
    const brokerURLParams = {
      ...this.params,
      Authorization: getAccessToken(),
    };
    
    for (const entry of Object.entries(brokerURLParams)) {
      const param = entry.join('=');
      parsedParams.push(param);
    }
    
    return `${this.brokerURL}?${parsedParams.join('&')}`;
  }
}

export default WSClient;
